import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 3.5C10.0672 3.5 8.50014 5.067 8.50014 7V11.5C8.50014 13.433 10.0672 15 12.0001 15C13.9331 15 15.5001 13.433 15.5001 11.5V7C15.5001 5.067 13.9331 3.5 12.0001 3.5ZM7.00014 7C7.00014 4.23858 9.23872 2 12.0001 2C14.7615 2 17.0001 4.23858 17.0001 7V11.5C17.0001 14.2614 14.7615 16.5 12.0001 16.5C9.23872 16.5 7.00014 14.2614 7.00014 11.5V7ZM4.82394 13.8127C5.20351 13.6469 5.64564 13.8202 5.81148 14.1997C6.85376 16.5853 9.23338 18.25 12.0001 18.25C14.7669 18.25 17.1465 16.5853 18.1889 14.1997C18.3547 13.8201 18.7968 13.6469 19.1764 13.8127C19.556 13.9786 19.7292 14.4207 19.5634 14.8003C18.386 17.4949 15.8095 19.4407 12.7501 19.7164V21.25C12.7501 21.6642 12.4143 22 12.0001 22C11.5859 22 11.2501 21.6642 11.2501 21.25V19.7164C8.19078 19.4407 5.61427 17.4949 4.43695 14.8003C4.27111 14.4207 4.44437 13.9786 4.82394 13.8127Z"
  })));
};

export { SvgMic as ReactComponent };
//# sourceMappingURL=mic.svg.js.map
